import { notificationApi } from "@/core/data/api";

export default async (data) => {
  return await notificationApi.createNotification(data);
};
